
import { defineComponent } from 'vue';
import commonApi from '@/api/common';

// const productList: string[];

export default defineComponent({
  name: 'RenewalUpgrade',
  data() {
    const lists: Array<object> = [];
    return {
      list: lists,
      isSelected: 0,
    };
  },
  mounted() {
    this.getDataConfForSaas();
  },
  components: {
  },
  methods: {
    chooseLevel(index: number) {
      this.isSelected = index;
      this.$emit('selectedByValue', this.list[index]);
    },
    getDataConfForSaas() {
      interface Data{
        data: [];
        success: boolean;
        message: string;
      }
      commonApi.getDataConfForSaas({ })
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            interface SData{
              createAccount: string;
              id: number;
              key: string;
              name: string;
              remark: string;
              sort: number;
              type: string;
              typeName: string;
              updateAccount: string;
              value: string;
            }
            data.forEach((element: SData) => {
              this.list.push(element);
            });
            this.chooseLevel(0);
          } else {
          // this.error(message);
            console.log(message);
          }
        });
    },
  },
});
